<template>
  <div id="app">
    <v-container>
      <v-snackbar v-model="message.snackbar" :timeout="message.snackbarTimeout" top>
        {{ message.snackbarText }}
        <v-btn dark text @click="message.snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-row>
        <v-col cols="12" md="6">
          <v-flex>
            <v-card>
              <v-system-bar color="blue darken-2"></v-system-bar>
              <v-app-bar dark color="blue">
                <v-toolbar-title>Unassigned Equipment</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchUnassignedAssetText"
                  placeholder="Search..."
                  hide-details
                  single-line
                ></v-text-field>
              </v-app-bar>
            </v-card>

            <v-list-item-group v-model="model" color="indigo">
              <v-list>
                <v-card-text>
                  <v-btn
                    color="error"
                    dark
                    small
                    absolute
                    top
                    left
                    fab
                    :search="searchAssetText"
                    @click="createAssetDialog = !createAssetDialog"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-card-text>
                <!-- <v-list> -->
                <v-list-group
                  v-for="item in filteredUnassignedAssets"
                  :key="item.id"
                  v-model="item.active"
                  :prepend-icon="item.action"
                  no-action
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.title"></v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <draggable
                    :move="checkMove"
                    @end="onAssignedEnd"
                    v-model="item.items"
                    color="indigo"
                    ghost-class="ghost"
                    :options="{group:'people'}"
                    style="min-height: 10px; margin-left: 56px;"
                  >
                    <v-list-item
                      v-for="subItem in item.items"
                      :key="subItem.id"
                      @click="showAsset(subItem.id)"
                    >
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="subItem.category + ' (' +  subItem.hpReference + ')'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </draggable>
                </v-list-group>
              </v-list>
            </v-list-item-group>
          </v-flex>
        </v-col>

        <v-col cols="12" md="6">
          <v-flex v-if="!bundleView">
            <v-card>
              <v-system-bar color="orange darken-2"></v-system-bar>
              <v-app-bar dark color="orange">
                <v-toolbar-title>Equipment</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-text-field
                  v-model="searchBundleText"
                  placeholder="Search..."
                  hide-details
                  single-line
                ></v-text-field>
              </v-app-bar>

              <div style="position: relative;">
                <v-btn
                  color="error"
                  dark
                  small
                  absolute
                  top
                  left
                  fab
                  @click="createBundleDialog = !createBundleDialog"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>

                <v-card flat v-for="bundle in filteredBundles" :key="bundle.id">
                  <v-layout flat row wrap :class="`pa-3`">
                    <v-flex xs2 sm2>
                      <!-- <v-avatar size="40" color="grey lighten-3" style="margin-left: 5px;">
                        <v-gravatar :email="bundle.assigned" default-img="mp" :size="40" />
                      </v-avatar>-->
                      <v-badge v-if="getAvatarUrl(bundle.assigned)" color="deep-purple accent-4" right overlap>
                        <template v-slot:badge>
                          <span>{{ bundle.assets }}</span>
                        </template>
                        <v-avatar size="40"  class="ml-2">
                          <img :src="getAvatarUrl(bundle.assigned)" />
                        </v-avatar>
                      </v-badge>
                      <v-badge v-else color="deep-purple accent-4" right overlap>
                        <template v-slot:badge>
                          <span>{{ bundle.assets }}</span>
                        </template>
                        <v-icon size="48" class="ml-1" color="grey lighten-1">account_circle</v-icon>
                      </v-badge>
                    </v-flex>
                    <v-flex xs2 sm2>
                      <div class="caption grey--text">Name</div>
                      <div class="body-2">{{ bundle.name }}</div>
                    </v-flex>
                    <v-flex xs5 sm5>
                      <div class="caption grey--text">Allocated to</div>
                      <div class="body-2">{{ bundle.assignedName }}</div>
                    </v-flex>
                    <v-flex xs3 sm3>
                      <div class="float-right">
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="mx-1"
                              right
                              fab
                              dark
                              x-small
                              color="success"
                              @click="viewEditBundle(bundle.id)"
                            >
                              <v-icon v-on="on" dark>mdi-account-switch</v-icon>
                            </v-btn>
                          </template>
                          <span>Switch or Delete Kit</span>
                        </v-tooltip>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="mx-1"
                              right
                              fab
                              dark
                              x-small
                              color="info"
                              @click="viewBundle(bundle.id)"
                            >
                              <v-icon v-on="on" dark>arrow_forward</v-icon>
                            </v-btn>
                          </template>
                          <span>View Kit</span>
                        </v-tooltip>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-card>
              </div>
            </v-card>
          </v-flex>

          <v-flex v-if="bundleView">
            <v-card>
              <v-system-bar color="orange darken-2"></v-system-bar>
              <v-app-bar dark color="orange">
                <v-toolbar-title>{{ bundleAssignedName }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-text-field
                  v-model="searchAssetText"
                  placeholder="Search..."
                  hide-details
                  single-line
                ></v-text-field>
              </v-app-bar>
            </v-card>
            <v-list-item-group color="indigo">
              <v-list subheader>
                <v-subheader></v-subheader>
                <draggable
                  :move="checkMove"
                  @end="onUnassignedEnd"
                  v-model="itemsassigned"
                  ghost-class="ghost"
                  :options="{group:'people'}"
                  style="min-height: 50px; border: 2px dashed orange;"
                >
                  <template v-for="item in filteredAssets">
                    <v-list-item :key="item.id">
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="item.category + ' (' +  item.hpReference + ')'"
                          @click="showAsset(item.id)"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-spacer></v-spacer>

                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-if="item.deliverTo"
                            v-on="on"
                            fab
                            dark
                            x-small
                            color="warning"
                            @click="viewStopSharing(item.id)"
                          >
                            <v-icon>mdi-home</v-icon>
                          </v-btn>
                        </template>
                        <span>Return from {{ item.deliverTo }}</span>
                      </v-tooltip>

                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-if="!item.deliverTo"
                            v-on="on"
                            fab
                            dark
                            x-small
                            color="accent"
                            @click="viewShare(item.id)"
                          >
                            <v-icon>mdi-truck</v-icon>
                          </v-btn>
                        </template>
                        <span>Deliver to...</span>
                      </v-tooltip>
                    </v-list-item>
                  </template>
                </draggable>
              </v-list>
              <v-divider></v-divider>
              <v-list>
                <v-card-actions>
                  <v-fab-transition>
                    <v-btn
                      color="#6fac46"
                      fab
                      small
                      dark
                      bottom
                      left
                      class="v-btn--back"
                      @click="bundleView = !bundleView"
                    >
                      <v-icon>keyboard_arrow_left</v-icon>
                    </v-btn>
                  </v-fab-transition>
                </v-card-actions>
              </v-list>
            </v-list-item-group>
          </v-flex>
        </v-col>
      </v-row>
      <!-- </v-app> -->

      <v-dialog v-model="listHPUsersDialog" scrollable max-width="500px">
        <v-card>
          <v-card-title>Deliver to...</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-text-field v-model="assetShare" :rules="[rules.required]" label="Company" required></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="listHPUsersDialog = false">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="shareAsset()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="createBundleDialog" max-width="700px">
        <v-card>
          <v-card-title class="grey--text">Create New Kit</v-card-title>
          <v-divider></v-divider>
          <br />

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-text-field
                v-model="bundleForm.description"
                :rules="[rules.required]"
                label="Description"
                required
              ></v-text-field>

              <v-select
                v-model="bundleForm.assignedTo"
                :items="staff"
                label="Assign to member of staff"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="createBundleDialog = false">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="onCreateBundle">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editBundleDialog" max-width="700px">
        <v-card>
          <v-card-title class="grey--text">Switch Kit</v-card-title>
          <v-divider></v-divider>
          <br />

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-text-field
                v-model="bundleForm.description"
                :rules="[rules.required]"
                label="Description"
                required
              ></v-text-field>

              <v-select
                v-model="bundleForm.assignedTo"
                :items="staff"
                label="Assign to member of staff"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="error" text @click="onDeleteBundle">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="editBundleDialog = false">Close</v-btn>
            <v-btn color="primary" text @click="onUpdateBundle">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="createAssetDialog" max-width="700px">
        <v-card>
          <v-card-title class="grey--text">Create Asset</v-card-title>
          <v-divider></v-divider>
          <br />

          <v-card-text>
            <v-select v-model="asset" :items="assets" label="Choose" outlined></v-select>

            <v-form ref="form" v-if="asset === 'Health Assessment'" lazy-validation>
              <v-select
                :items="assetTemplateSelect"
                v-model="description"
                filled
                :rules="[rules.required]"
                label="Description"
                @change="onAssetTemplateSelect"
              ></v-select>
              <v-text-field v-model="model" :rules="[rules.required]" label="Model" required></v-text-field>
              <v-select
                v-model="maintenance"
                :items="maintenanceList"
                label="Maintenance frequency"
              ></v-select>
              <v-text-field
                v-model="reference"
                :rules="[rules.required]"
                label="HP reference"
                required
              ></v-text-field>
              <v-text-field
                v-model="serial"
                :rules="[rules.required]"
                label="Serial number"
                required
              ></v-text-field>
              <v-text-field
                v-model="cost"
                :rules="[rules.required, rules.currency]"
                label="Cost"
                prefix="£"
                @change="filterCurrency"
                required
              ></v-text-field>
              <v-text-field
                v-model="supplierLink"
                :rules="[rules.url]"
                label="Supplier app link"
                prefix="http://"
                required
              ></v-text-field>
            </v-form>

            <v-form ref="form" v-if="asset === 'Health Promotion'" lazy-validation>
              <v-select
                :items="assetTemplateSelect"
                v-model="description"
                filled
                :rules="[rules.required]"
                label="Description"
                @change="onAssetTemplateSelect"
              ></v-select>
              <v-text-field v-model="model" :rules="[rules.required]" label="Model" required></v-text-field>
              <v-select
                v-model="maintenance"
                :items="maintenanceList"
                label="Maintenance frequency"
              ></v-select>
              <v-text-field
                v-model="reference"
                :rules="[rules.required]"
                label="HP Reference"
                required
              ></v-text-field>
              <v-text-field
                v-model="serial"
                :rules="[rules.required]"
                label="Serial number"
                required
              ></v-text-field>
              <v-text-field
                v-model="cost"
                :rules="[rules.required, rules.currency]"
                label="Cost"
                prefix="£"
                @change="filterCurrency"
                required
              ></v-text-field>
              <v-text-field
                v-model="supplierLink"
                :rules="[rules.url]"
                label="Supplier app link"
                prefix="http://"
                required
              ></v-text-field>
            </v-form>

            <v-form ref="form" v-if="asset === 'IT'" lazy-validation>
              <v-select
                :items="assetTemplateSelect"
                v-model="description"
                filled
                :rules="[rules.required]"
                label="Description"
                @change="onAssetTemplateSelect"
              ></v-select>
              <v-text-field v-model="model" :rules="[rules.required]" label="Model" required></v-text-field>
              <v-select
                v-model="maintenance"
                :items="maintenanceList"
                label="Maintenance frequency"
              ></v-select>
              <v-text-field
                v-model="reference"
                :rules="[rules.required]"
                label="HP Reference"
                required
              ></v-text-field>
              <v-text-field
                v-model="serial"
                :rules="[rules.required]"
                label="Serial number"
                required
              ></v-text-field>
              <v-text-field
                v-model="cost"
                :rules="[rules.required, rules.currency]"
                label="Cost"
                prefix="£"
                @change="filterCurrency"
                required
              ></v-text-field>
              <v-text-field
                v-model="supplierLink"
                :rules="[rules.url]"
                label="Supplier app link"
                prefix="http://"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                hint="Bitlocker code or anything else relevant"
                :persistent-hint="true"
              ></v-text-field>
            </v-form>

            <v-form ref="form" v-if="asset === 'Office Furniture'" lazy-validation>
              <v-select
                :items="assetTemplateSelect"
                v-model="description"
                filled
                :rules="[rules.required]"
                label="Description"
                @change="onAssetTemplateSelect"
              ></v-select>
              <v-text-field v-model="model" :rules="[rules.required]" label="Model" required></v-text-field>
              <v-select
                v-model="maintenance"
                :items="maintenanceList"
                label="Maintenance frequency"
              ></v-select>
              <v-text-field
                v-model="reference"
                :rules="[rules.required]"
                label="HP Reference"
                required
              ></v-text-field>
              <v-text-field
                v-model="serial"
                :rules="[rules.required]"
                label="Serial number"
                required
              ></v-text-field>
              <v-text-field
                v-model="cost"
                :rules="[rules.required, rules.currency]"
                label="Cost"
                prefix="£"
                @change="filterCurrency"
                required
              ></v-text-field>
              <v-text-field
                v-model="supplierLink"
                :rules="[rules.url]"
                label="Supplier app link"
                prefix="http://"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="createAssetDialog = false">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="onCreateAsset">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="unshareUserDialog" max-width="450">
        <v-card>
          <v-card-title class="headline red--text">Return asset back to office?</v-card-title>

          <v-card-actions>
            <div class="flex-grow-1"></div>

            <v-btn color="blue darken-1" text @click="unshareUserDialog = false">Cancel</v-btn>

            <v-btn color="red darken-1" text @click="stopSharingAsset()">Stop sharing</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Aws from "aws-sdk";
import { Auth } from "aws-amplify";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import { onUpdateEventSlot } from "./../graphql/subscriptions";
import draggable from "vuedraggable";
import axios from "axios";
import { hpUser } from "../classes/hpUser";
export default {
  components: {
    draggable
  },
  mounted() {
    this.$root.$on("addToAssetTemplate", asset => {
      this.assetTemplateSelect.push({
        text: asset.category,
        value: asset.id
      });
      this.assetTemplate.push(asset);
    });

    this.$root.$on("deleteFromAssetTemplate", assetId => {
      this.assetTemplateSelect = this.assetTemplateSelect.filter(function(obj) {
        return obj.value !== assetId;
      });
    });
  },
  created() {
    this.getUsers();
  },
  data() {
    return {
      unassignedAssets: [
        {
          action: "favorite",
          title: "Health Assessment",
          items: []
        },
        {
          action: "receipt",
          title: "Health Promotion",
          // active: true,
          items: []
        },
        {
          action: "laptop",
          title: "IT",
          items: []
        },
        {
          action: "add_to_queue",
          title: "Office Furniture",
          items: []
        }
        // {
        //   action: "devices",
        //   title: "Dongle",
        //   items: []
        // },
        // {
        //   action: "sim_card",
        //   title: "Sim Card",
        //   items: []
        // }
      ],
      bundles: [],
      itemsassigned: [],
      assetTemplate: [],
      assetTemplateSelect: [],
      message: {
        showError: false,
        errorMessage: null,
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
        show: false,
        message: null
      },
      staff: [],
      createAssetDialog: false,
      createBundleDialog: false,
      editBundleDialog: false,
      listHPUsersDialog: false,
      unshareUserDialog: false,
      asset: "",
      assets: [
        "Health Assessment",
        "Health Promotion",
        "IT",
        "Office Furniture"
      ],
      maintenanceList: ["N/A", "Daily", "Weekly", "Monthly", "Yearly"],
      rules: {
        required: v => !!v || "This field is required.",
        minimum: v => v.length >= 8 || "Minimum 8 characters",
        currency: v =>
          /^\$?(([1-9]\d{0,4}(,\d{3})*)|0)?\.\d{1,2}$/.test(v) ||
          "GBP format is required eg 10.00",
        url: function(v) {
          if (!!v) {
            // let regex = /^((http[s]?|ftp):\/)?\/?([^:\/\s]+)((\/\w+)*\/)([\w\-\.]+[^#?\s]+)(.*)?(#[\w\-]+)?$/;
            const regex = /^((ftp|http|https):\/\/).([A-z]+)\.([A-z]{2,})/;
            if (!regex.test("https://" + v)) {
              return "Url not valid";
            }
          }
          return true;
        }
      },
      hpUsers: [],
      bundleView: false,
      bundleForm: [],
      bundleAssignedName: "",
      bundleAssignedId: "",
      description: "",
      reference: "",
      serial: "",
      model: "",
      cost: "",
      password: "",
      assetShare: "",
      maintenance: "",
      supplierLink: "",
      movedItem: [],
      searchAssetText: "",
      searchUnassignedAssetText: "",
      searchBundleText: ""
    };
  },
  methods: {
    checkMove: function(evt) {
      this.movedItem = evt.draggedContext.element;
    },
    onUnassignedEnd: function() {
      let that = this;

      const query = `mutation UpdateEquipmentLogAsset($asset: ID! $bundle: ID!) {
                updateEquipmentLogAsset (input: {
                    id: $asset,
                    equipmentLogAssetEquipmentLogBundleId: $bundle,
                    deliverTo: null
                }){
                    id,
                    serial,
                    cost,
                    category,
                    product,
                    model,
                    deliverTo,
                    hpReference
                }
            }`;

      API.graphql(
        graphqlOperation(query, {
          asset: that.movedItem.id,
          bundle: "702fd409-7c13-456d-97ce-c72da624d3d2"
        })
      ).then(result => {
        this.unassignedAssets = [
          {
            action: "favorite",
            title: "Health Assessment",
            items: []
          },
          {
            action: "receipt",
            title: "Health Promotion",
            // active: true,
            items: []
          },
          {
            action: "laptop",
            title: "IT",
            items: []
          },
          {
            action: "add_to_queue",
            title: "Office Furniture",
            items: []
          }
        ];

        let asset = result.data.updateEquipmentLogAsset;
        for (var i = 0; i < this.unassignedAssets.length; i++) {
          if (asset.product === this.unassignedAssets[i].title) {
            let items = this.unassignedAssets[i].items;
            this.unassignedAssets[i].active = true;
            for (var c = 0; c < items.length; c++) {
              if (items[c].id === that.movedItem.id) {
                items[c].id = asset.id;
                items[c].serial = asset.serial;
                items[c].model = asset.model;
                items[c].cost = asset.cost;
                items[c].category = asset.category;
                items[c].hpReference = asset.hpReference;
                items[c].shareEmail = asset.shareEmail;
                items[c].sharePerson = asset.sharePerson;
                items[c].searchField = asset.hpReference + " " + asset.category;
              }
            }
          }
        }

        that.getUnassignedBundle();
        this.onCreateHistory("Assign to Unassigned Bundle", asset.id);
        this.message.snackbarText = "Asset Assigned to Unassigned Bundle";
        this.message.snackbar = true;
      });
    },
    onAssignedEnd: function() {
      let that = this;

      const query = `mutation UpdateEquipmentLogAsset($asset: ID! $bundle: ID!) {
                updateEquipmentLogAsset (input: {
                    id: $asset,
                    equipmentLogAssetEquipmentLogBundleId: $bundle
                }){
                    id,
                    serial,
                    model,
                    category,
                    product
                }
            }`;

      API.graphql(
        graphqlOperation(query, {
          asset: that.movedItem.id,
          bundle: that.bundleAssignedId
        })
      ).then(result => {
        let asset = result.data.updateEquipmentLogAsset;
        this.onCreateHistory(
          "Asset Assigned to " + this.bundleAssignedName,
          asset.id
        );

        this.message.snackbarText =
          "Asset Assigned to " + this.bundleAssignedName;
        this.message.snackbar = true;
      });
    },
    showAsset: function(assetId) {
      this.$router.push({ name: "asset", params: { id: assetId } });
    },
    getAssetTemplates() {
      const query = `query ListEquipmentLogAssetTemplates {
                listEquipmentLogAssetTemplates (limit: 1000) {
                    items {
                        id,
                        category,
                        model,
                        maintenance,
                    }
                }
            }`;
      API.graphql(graphqlOperation(query)).then(result => {
        let assetTemplate = result.data.listEquipmentLogAssetTemplates.items;
        assetTemplate = _.orderBy(assetTemplate, "category", "asc");
        for (var i = 0; i < assetTemplate.length; i++) {
          this.assetTemplate = assetTemplate;
          this.assetTemplateSelect.push({
            text: assetTemplate[i].category,
            value: assetTemplate[i].id
          });
        }
      });
    },
    onCreateAsset: function() {
      let that = this;
      if (this.$refs.form.validate()) {
        // Unassigned
        const query = `mutation CreateEquipmentLogAsset(
                    $product: String!
                    $category: String!
                    $hpReference: String!
                    $model: String!
                    $serial: String!
                    $purchaseDate: String!
                    $cost: String!
                    $maintenance: String
                    $supplierLink: String
                    $createdAt: String!
                    $isDeleted: Int!
                    ) {
                    createEquipmentLogAsset(input: {
                        product: $product,
                        category: $category,
                        hpReference: $hpReference,
                        model: $model,
                        serial: $serial,
                        purchaseDate: $purchaseDate,
                        cost: $cost,
                        maintenance: $maintenance,
                        supplierLink: $supplierLink,
                        createdAt: $createdAt,
                        isDeleted: $isDeleted,
                        equipmentLogAssetEquipmentLogBundleId:"702fd409-7c13-456d-97ce-c72da624d3d2",
                    }){
                        id,
                        product,
                        category,
                        hpReference,
                        model,
                        serial,
                        purchaseDate,
                        cost,
                        maintenance,
                        supplierLink,
                        password,
                        createdAt,
                        isDeleted
                    }
                }`;
        let templateAsset = this.assetTemplateSelect.filter(
          item => item.value === this.description
        );

        API.graphql(
          graphqlOperation(query, {
            product: this.asset,
            category: templateAsset[0].text,
            hpReference: this.reference,
            model: this.model,
            serial: this.serial,
            purchaseDate: new Date().toISOString(),
            cost: this.cost,
            maintenance: this.maintenance,
            supplierLink: this.supplierLink ? this.supplierLink : null,
            createdAt: new Date().toISOString(),
            isDeleted: 0
          })
        ).then(result => {
          let asset = result.data.createEquipmentLogAsset;
          for (var i = 0; i < this.unassignedAssets.length; i++) {
            if (asset.product === this.unassignedAssets[i].title) {
              that.unassignedAssets[i].items.push({
                id: asset.id,
                serial: asset.serial,
                model: asset.model,
                cost: asset.cost,
                maintenance: asset.maintenance,
                category: asset.category,
                hpReference: asset.hpReference
              });

              this.onCreateHistory("New Asset Created", asset.id);

              this.createAssetDialog = false;
              this.message.snackbarText = "New Asset Created";
              this.message.snackbar = true;

              this.asset = "";
              this.description = "";
              this.serial = "";
              this.maintenance = "";
              this.model = "";
              this.reference = "";
              this.purchaseDate = "";
              this.cost = "";
              this.createdAt = "";
              this.supplierLink = "";
              this.password = "";
            }
          }
        });
      }
    },
    onCreateHistory: function(history, assetId) {
      const mutation = `mutation CreateEquipmentLogHistory(
                    $date: String! 
                    $createdBy: String!
                    $createdByEmail: String!
                    $history: String!
                    $equipmentLogHistoryEquipmentLogAssetId: ID!
                ) {
                createEquipmentLogHistory (input: {
                    date: $date
                    createdBy: $createdBy
                    createdByEmail: $createdByEmail
                    history: $history
                    equipmentLogHistoryEquipmentLogAssetId: $equipmentLogHistoryEquipmentLogAssetId
                }){
                    id,
                    date
                    createdBy
                    createdByEmail
                    history
                }
            }`;

      Auth.currentAuthenticatedUser()
        .then(user => {
          let staff = this.staff.filter(
            staff => staff.value === user.attributes.email
          );

          API.graphql(
            graphqlOperation(mutation, {
              date: new Date().toISOString(),
              createdBy: staff[0].text,
              createdByEmail: staff[0].value,
              history: history,
              equipmentLogHistoryEquipmentLogAssetId: assetId
            })
          ).then(result => {
            console.log(result);
          });
        })
        .catch(err => console.log(err));
    },
    onCreateBundle: function() {
      let that = this;
      if (this.$refs.form.validate()) {
        const query = `mutation CreateEquipmentLogBundle($name: String! $assigned: String! $date: String!) {
                    createEquipmentLogBundle(input: {
                        name: $name,
                        assigned: $assigned,
                        createdAt: $date,
                        isDeleted:0,
                    }){
                        id
                        name
                        assigned
                        createdAt
                    }
                }`;

        API.graphql(
          graphqlOperation(query, {
            name: this.bundleForm.description,
            assigned: this.bundleForm.assignedTo,
            date: new Date().toISOString()
          })
        ).then(result => {
          let bundle = result.data.createEquipmentLogBundle;
          const assignedToPerson = this.hpUsers.filter(
            user => user.username === bundle.assigned
          );
          that.bundles.push({
            id: bundle.id,
            name: bundle.name,
            createdAt: bundle.createdAt,
            assigned: bundle.assigned,
            avatar: assignedToPerson[0].s3avatarUrl
          });
          this.message.snackbarText = "New Bundle Created";
          this.message.snackbar = true;
          this.createBundleDialog = false;
        });
      }
    },
    onUpdateBundle: function() {
      let that = this;
      if (this.$refs.form.validate()) {
        const query = `mutation UpdateEquipmentLogBundle($id: ID! $name: String! $assigned: String!) {
                    updateEquipmentLogBundle(input: {
                        id: $id,
                        name: $name,
                        assigned: $assigned,
                    }){
                        id,
                        name,
                        assigned,
                        createdAt
                    }
                }`;

        API.graphql(
          graphqlOperation(query, {
            id: this.bundleForm.id,
            name: this.bundleForm.description,
            assigned: this.bundleForm.assignedTo
          })
        ).then(result => {
          let bundle = result.data.updateEquipmentLogBundle;

          let updateBundle = that.bundles.filter(
            bundle => bundle.id === this.bundleForm.id
          );
          updateBundle[0].id = bundle.id;
          updateBundle[0].assigned = bundle.assigned;
          updateBundle[0].name = bundle.name;

          this.message.snackbarText =
            "Bundle " + this.bundleForm.description + " Updated";
          this.message.snackbar = true;
          this.editBundleDialog = false;
        });
      }
    },
    onDeleteBundle: function() {
      let that = this;
      if (this.$refs.form.validate()) {
        const query = `mutation UpdateEquipmentLogBundle($id: ID! $isDeleted: Int!) {
                    updateEquipmentLogBundle(input: {
                        id: $id,
                        isDeleted: $isDeleted,
                    }){
                        id,
                        name,
                        assigned,
                        createdAt,
                        isDeleted
                    }
                }`;

        API.graphql(
          graphqlOperation(query, { id: this.bundleForm.id, isDeleted: 1 })
        ).then(result => {
          let bundle = result.data.updateEquipmentLogBundle;

          let updateBundle = that.bundles.filter(
            bundle => bundle.id !== this.bundleForm.id
          );
          that.bundles = updateBundle;

          this.message.snackbarText =
            "Bundle " + this.bundleForm.description + " Deleted";
          this.message.snackbar = true;
          this.editBundleDialog = false;
        });
      }
    },
    onAssetTemplateSelect() {
      let templateAsset = this.assetTemplate.filter(
        item => item.id === this.description
      );
      this.model = templateAsset[0].model;
      this.maintenance = templateAsset[0].maintenance;
    },
    viewEditBundle: function(bundleId) {
      // bundleForm
      const query = `query GetEquipmentLogBundle($id: ID!) {
                getEquipmentLogBundle (id: $id){
                    id,
                    name,
                    assigned
                }
            }`;

      API.graphql(graphqlOperation(query, { id: bundleId })).then(result => {
        let bundle = result.data.getEquipmentLogBundle;
        this.bundleForm = {
          id: bundle.id,
          description: bundle.name,
          assignedTo: bundle.assigned
        };
        this.editBundleDialog = true;
      });
    },
    viewBundle: function(bundleId) {
      let that = this;
      that.itemsassigned = [];

      const query = `query ListEquipmentLogBundles($id: ID!) {
                listEquipmentLogBundles(
                    limit: 100,
                    filter: { 
                        isDeleted: { eq: 0 },
                        id: { eq: $id }
                    }
                ) {
                    items {
                        id,
                        name,
                        assigned,
                        createdAt,
                        equipmentLogAsset(
                            limit: 100,
                            filter: {
                                isDeleted: { eq: 0 }
                            }
                        ) {
                            items {
                                id,
                                product,
                                cost,
                                category,
                                hpReference,
                                model,
                                serial,
                                maintenance,
                                deliverTo
                            }
                        }
                    }
                }
            }`;

      API.graphql(graphqlOperation(query, { id: bundleId })).then(result => {
        let bundle = result.data.listEquipmentLogBundles.items[0];
        let assets = bundle.equipmentLogAsset.items;
        assets.forEach(function(asset) {
          that.itemsassigned.push({
            id: asset.id,
            serial: asset.serial,
            model: asset.model,
            cost: asset.cost,
            maintenance: asset.maintenance,
            category: asset.category,
            hpReference: asset.hpReference,
            deliverTo: asset.deliverTo
          });
        });

        that.itemsassigned.sort((a, b) => {
          return a.category
            .toLowerCase()
            .localeCompare(b.category.toLowerCase());
        });

        this.bundleAssignedName = bundle.name;
        this.bundleAssignedId = bundle.id;
      });
      this.bundleView = !this.bundleView;
    },
    viewShare(assetId) {
      this.asset = assetId;
      this.listHPUsersDialog = !this.listHPUsersDialog;
    },
    viewStopSharing(assetId) {
      this.asset = assetId;
      this.unshareUserDialog = !this.unshareUserDialog;
    },
    async getUsers() {
      let that = this;
      that.hpUsers = [];
      that.staff = [];

      let hpUserObj = new hpUser();
      that.hpUsers = await hpUserObj.getUsers();
      that.hpUsers = _.orderBy(that.hpUsers, "firstName", "asc");
      that.hpUsers.forEach(function(user) {
        that.staff.push({
          text: user.firstName + " " + user.lastName,
          value: user.username
        });
      });

      this.getUnassignedBundle();
      this.getAssignedBundle();
      this.getAssetTemplates();
    },
    async getAssignedBundle() {
      const query = `query ListEquipmentLogBundles {
      listEquipmentLogBundles(
          limit: 100,
          filter: { 
              isDeleted: { eq: 0 },
              name: { ne: "Unassigned" }
          }
      ) {
          items {
              id
              name
              assigned
              createdAt
              equipmentLogAsset(
                limit: 100,
                filter: {
                  isDeleted: { eq: 0 }
                }
              ) {
                items {
                  id
                }
              }
          }
      }}`;

      const bundleObj = await API.graphql(graphqlOperation(query)).then(
        result => {
          let bundles = result.data.listEquipmentLogBundles.items;
          for (var i = 0; i < bundles.length; i++) {
            const assignedToPerson = this.hpUsers.filter(
              user => user.username === bundles[i].assigned
            );

            this.bundles.push({
              id: bundles[i].id,
              name: bundles[i].name,
              assigned: bundles[i].assigned,
              assignedName: assignedToPerson[0]
                ? `${assignedToPerson[0].firstName} ${assignedToPerson[0].lastName}`
                : bundles[i].assigned,
              createdAt: bundles[i].createdAt,
              avatar: null,
              assets: bundles[i].equipmentLogAsset.items.length
              // avatar: (assignedToPerson[0]) ? assignedToPerson[0].s3avatarUrl : null
            });
          }

          const sortAlphaNum = this.bundles.sort(function(a, b) {
            return a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: "base"
            });
          });
          this.bundles = sortAlphaNum;
        }
      );
    },
    async getUnassignedBundle() {
      let that = this;

      const query = `query ListEquipmentLogBundles {
                listEquipmentLogBundles(
                    limit: 1000,
                    filter: { 
                        isDeleted: { eq: 0 },
                        name: { eq: "Unassigned" }
                    }
                ) {
                    items {
                        id,
                        name,
                        assigned,
                        createdAt,
                        equipmentLogAsset(
                            limit: 1000,
                            filter: {
                                isDeleted: { eq: 0 }
                            }
                        ) {
                            items {
                                id,
                                product,
                                category,
                                hpReference,
                                model,
                                serial
                            }
                        }
                    }
                }}`;

      const bundleObj = await API.graphql(graphqlOperation(query)).then(
        result => {
          let bundles = result.data.listEquipmentLogBundles.items;
          bundles.forEach(function(bundle) {
            let assets = bundle.equipmentLogAsset.items;
            assets.forEach(function(asset) {
              for (var i = 0; i < that.unassignedAssets.length; i++) {
                if (asset.product === that.unassignedAssets[i].title) {
                  that.unassignedAssets[i].items.push({
                    id: asset.id,
                    serial: asset.serial,
                    model: asset.model,
                    cost: asset.cost,
                    category: asset.category,
                    hpReference: asset.hpReference,
                    searchField: asset.category + " " + asset.hpReference
                  });
                }
              }
            });
          });
        }
      );
      for (var i = 0; i < that.unassignedAssets.length; i++) {
        that.unassignedAssets[i].items.sort((a, b) => {
          return new Intl.Collator("en", {
            numeric: true,
            sensitivity: "accent"
          }).compare(a.searchField, b.searchField);
        });
      }
    },
    shareAsset() {
      let that = this;
      const query = `mutation UpdateEquipmentLogAsset($asset: ID! $deliverTo: String!) {
                updateEquipmentLogAsset (input: {
                    id: $asset,
                    deliverTo: $deliverTo
                }){
                    id,
                    serial,
                    model,
                    cost,
                    category,
                    deliverTo
                }
            }`;

      API.graphql(
        graphqlOperation(query, {
          asset: this.asset,
          deliverTo: this.assetShare
        })
      ).then(result => {
        that.listHPUsersDialog = false;
        let asset = result.data.updateEquipmentLogAsset;

        let updateAsset = that.itemsassigned.filter(
          item => item.id === this.asset
        );
        updateAsset[0].id = asset.id;
        updateAsset[0].serial = asset.serial;
        updateAsset[0].model = asset.model;
        updateAsset[0].cost = asset.cost;
        updateAsset[0].category = asset.category;
        updateAsset[0].deliverTo = asset.deliverTo;

        this.onCreateHistory("Asset delivered to " + asset.deliverTo, asset.id);

        this.message.snackbarText = "Asset delivered to " + asset.deliverTo;
        this.message.snackbar = true;
      });
    },
    stopSharingAsset() {
      let that = this;
      const query = `mutation UpdateEquipmentLogAsset($asset: ID!) {
                updateEquipmentLogAsset (input: {
                    id: $asset,
                    deliverTo: null,
                }){
                    id,
                    serial,
                    model,
                    cost,
                    category,
                    deliverTo
                }
            }`;

      API.graphql(graphqlOperation(query, { asset: this.asset })).then(
        result => {
          that.unshareUserDialog = false;
          let asset = result.data.updateEquipmentLogAsset;

          let updateAsset = that.itemsassigned.filter(
            item => item.id === this.asset
          );
          updateAsset[0].id = asset.id;
          updateAsset[0].serial = asset.serial;
          updateAsset[0].model = asset.model;
          updateAsset[0].cost = asset.cost;
          updateAsset[0].category = asset.category;
          updateAsset[0].deliverTo = asset.deliverTo;

          this.onCreateHistory("Asset returned to office", asset.id);

          this.message.snackbarText = "Asset returned to office";
          this.message.snackbar = true;
        }
      );
    },
    filterCurrency() {
      if (!isNaN(this.cost)) {
        this.cost = parseFloat(this.cost).toFixed(2);
      }
    },
    getAvatarUrl(username) {
      const staff = this.hpUsers.filter(user => user.username === username);
      return staff[0] ? staff[0].s3avatarUrl : null;
    }
  },
  computed: {
    filteredBundles() {
      if (this.searchBundleText.length > 0) {
        return this.bundles.filter(item => {
          return (
            item.name
              .toLowerCase()
              .includes(this.searchBundleText.toLowerCase()) ||
            item.assigned
              .toLowerCase()
              .includes(this.searchBundleText.toLowerCase())
          );
        });
      }
      return this.bundles;
    },
    filteredAssets() {
      if (this.searchAssetText.length > 0) {
        return this.itemsassigned.filter(item => {
          return (
            item.hpReference
              .toLowerCase()
              .includes(this.searchAssetText.toLowerCase()) ||
            item.category
              .toLowerCase()
              .includes(this.searchAssetText.toLowerCase())
          );
        });
      }
      return this.itemsassigned;
    },
    filteredUnassignedAssets() {
      const that = this;
      if (that.searchUnassignedAssetText.length > 2) {
        let filteredAssets = {};

        Object.keys(this.unassignedAssets).forEach(function(key) {
          filteredAssets[key] = that.unassignedAssets[key].items.filter(
            function(item) {
              return (
                item.searchField
                  .toLowerCase()
                  .indexOf(that.searchUnassignedAssetText.toLowerCase()) !== -1
              );
            }
          );
        });

        let assets = [];
        Object.keys(filteredAssets).forEach(function(key) {
          if (filteredAssets[key].length > 0) {
            assets.push({
              action: that.unassignedAssets[key].action,
              title: that.unassignedAssets[key].title,
              active: that.unassignedAssets[key].active,
              items: []
            });
            assets[assets.length - 1].items = filteredAssets[key];
          }
        });
        return assets;
      }
      return this.unassignedAssets;
    }
  }
};
</script>
<style>
.ghost {
  opacity: 0.5;
  background: #b9bfe4;
  border: 2px dashed orange;
}
</style>